import { axiosInstance } from "../config";
import { track } from "./analytics";
import { metaCookies, trackTrialCheckoutPixel } from "./adPixels";
import { getRewardfulReferral } from "./rewardful";

// "Start for $1": straight to Stripe's hosted Checkout ($1 today, 120 credits,
// 3 days of Pro, then Pro monthly). Stripe sends them back to
// /home?paywall=paid&trial=1, where ForYouPage waits for the webhook and fires
// the StartTrial pixel. Throws with the server's error code (e.g. "trial_used").
export async function openTrialCheckout({ source = "app" } = {}) {
  trackTrialCheckoutPixel(); // also sets Meta's _fbp cookie before checkout
  track("trial_checkout_opened", { source });
  const referral = getRewardfulReferral();
  const { data } = await axiosInstance.post("/trial/checkout", {
    success_url: `${window.location.origin}/home?paywall=paid&trial=1`,
    cancel_url: `${window.location.origin}/home`,
    ...metaCookies(),
    ...(referral ? { referral } : {}),
  });
  if (!data?.url) throw new Error("checkout_failed");
  window.location.href = data.url;
}
